import RadiosBinaryDirective from 'edge/platform/atomic_design/molecules/directives/RadiosBinaryDirective';

export default angular.module('edge.platform.atomic_design.molecules', []).directive('gwPlRadiosBinary', RadiosBinaryDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/atomic_design/molecules/module.js
// module id = 1879
// module chunks = 0